
<div>
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Company" class="table-header-title">{{'termsAndConditions.consent.company' | translate}}</th>
                    <th id="FirstName" class="table-header-title">{{'termsAndConditions.consent.firstName' | translate}}</th>
                    <th id="LastName" class="table-header-title">{{'termsAndConditions.consent.lastName' | translate}}</th>
                    <th id="Response" class="table-header-title">{{'termsAndConditions.consent.response' | translate}}</th>
                    <th id="ResponseDate" class="table-header-title">{{'termsAndConditions.consent.responseDate' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let cookie of cookies">
                    <tr class="table-container row-container">
                        <td HJSuppress id="Company" class="column-content">
                            {{cookie.companyName}}
                        </td>
                        <td HJSuppress id="FirstName" class="column-content">
                            {{cookie.firstName}}
                        </td>
                        <td HJSuppress id="LastName" class="column-content">
                            {{cookie.lastName}}
                        </td>
                        <td HJSuppress id="Response" class="column-content">
                            {{cookie.value}}
                        </td>
                        <td HJSuppress id="ResponseDate" class="column-content">
                            {{cookie.consentDate | localizedDate}}
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>
